/** @format */

import {useTranslation} from 'react-i18next';

import {TariffInfo} from 'features/tariffs/types';
import {getSpentNumber} from 'features/tariffs/helpers/getSpentNumber';

interface Options {
  maxAiReportRuns?: null | number;
  maxSubAccounts?: null | number;
  spentMax?: null | number;
}

const useGetTariffInfo = ({maxSubAccounts, spentMax, maxAiReportRuns}: Options): TariffInfo => {
  const {t} = useTranslation();

  const aiReports = maxAiReportRuns ?? 0;
  const aiReportsText = `${t('plurals.ai_reports', {count: aiReports})} ${t('на каждый кабинет')}`;

  const cabinetsText = t('plurals.cabinets', {
    count: maxSubAccounts ?? 0,
  });

  const {isMillion, spent} = getSpentNumber(spentMax ?? null);
  const millionText = isMillion ? ' млн' : '';
  const budgetText = `Общий бюджет до ${spent}${millionText} ₽/месяц`;

  return {
    aiReports: aiReportsText,
    cabinets: cabinetsText,
    budget: budgetText,
  };
};

export {useGetTariffInfo};
